module.exports = __webpack_public_path__ + "img/yellow-button@2x.e33ac754.png";